// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__21xjS","toggle":"styles_toggle__1hkBQ","preview":"styles_preview__2YEso"};